import { AddressDTO } from "./Common";
import { MediaInfoDTO } from "./Media";
import { CommentDTO, FailureModeDTO, LaborLineDTO, PartLineDTO } from "./WarrantyClaimManagement";

export type IPreAuth = {
    action?: any;
    preAuthNumber?: string;
    hin: string;
    customerId: string;
    customerName: string;
    model?: string;
    modelYear?: string;
    totalCost?: number;
    claimStatusDescription: string;
    claimStatus: string;
    failureDate: string;
    submitDate?: string;
    approvalDate?: string;
}

interface PreAuthHeaderDTO {
    preAuthNumber: string;
    hin: string;
    customerId: string;
    customerName: string;
    model?: string;
    modelYear?: string;
    failureDate?: Date;
    claimStatus?: string;
    claimStatusDescription: string;
    totalCost?: number;
    submitDate?: Date;
    appovalDate?: Date;
}

export interface PreAuthLaborLineDTO extends LaborLineDTO {
    
}

export interface PreAuthPartLineDTO extends PartLineDTO {
    
}

export interface PreAuthFailureModeDTO extends FailureModeDTO {
    laborLines: PreAuthLaborLineDTO[];
    partLines: PreAuthPartLineDTO[];
}

interface ClaimPayableContactDTO {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: AddressDTO;
}

export interface WarrantyPreAuthDTO extends PreAuthHeaderDTO {
    warrantyRegistrationId?: string;   
    hourMeterReading?: string;
    failureModes: PreAuthFailureModeDTO[];
    dealerComments?: CommentDTO[];
    internalComments?: CommentDTO[];
    mediaList: MediaInfoDTO[];
    engineModel?: string;
    serialNumber?: string;
    ownerFirstName?: string;
    ownerLastName?: string;
    ownerEmail?: string;
    ownerPhone?: string;
    ownerAddress?: AddressDTO;
    warrantyType?: string;
    warrantyPurchaseDate?: Date;
    warrantyExpirationDate?: Date;
    overrideClaimPayable?: boolean;
    claimPayableContact: ClaimPayableContactDTO;
}

export const getEmptyPart = (): PreAuthPartLineDTO => ({
    lineNumber: 0,
    lineStatusCode: "PEN",
    partNumber: "",
    partDescription: "",
    quantity: 0,
    sequenceCode: "",
    costPer: 0,
    serviceBulletin: "",
    rmaRequired: false,
    totalCost: 0
});

export const getEmptyLabor = (): PreAuthLaborLineDTO => ({
    lineNumber: 0,
    laborCode: {
        standardHours: 0,
        allowOverride: false,
        overrideDescription: false,
        overrideRate: false,
        name: "",
        value: ""
    },
    hours: 0,
    rate: 0,
    cost: 0,
    lineStatusCode: "PEN"
});

export const getEmptyFailureMode = (): PreAuthFailureModeDTO => ({
    lineNumber: 0,
    complaint: "",
    cause: "",
    correction: "",
    repairTech: "",
    laborLines: [],
    partLines: []
});

export const getEmptyAddress = (): AddressDTO => ({
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
});


